import { useTranslation } from 'react-i18next';

const WhyChooseUs = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className="py-4 mt-6 mb-6 text-center block-bglight text-xl-start py-sm-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="text-center h1">Por qué elegirnos</h3>
                            <ul className="row o-list-features o-list-features_rounded">
                                <li className="col-12 col-sm-3">
                                    <span className="round">
                                        <img src="https://pro-static.h10hotels.com/gallery/Icono_Ubicacion.svg" alt="Icono_Ubicacion" />
                                    </span>
                                    <span>Excelente ubicación en centro de ciudad o primera línea de mar</span>
                                </li>
                                <li className="col-12 col-sm-3">
                                    <span className="round">
                                        <img src="https://pro-static.h10hotels.com/gallery/Icono_Olas.svg" alt="Piscina" />
                                    </span>
                                    <span>Flexibilidad</span>
                                </li>
                                <li className="col-12 col-sm-3">
                                    <span className="round">
                                        <img src="https://pro-static.h10hotels.com/gallery/Icono_SaludoManos.svg" alt="Icono_SaludoManos" />
                                    </span>
                                    <span>Eventos a medida</span>
                                </li>
                                <li className="col-12 col-sm-3">
                                    <span className="round">
                                        <img src="https://pro-static.h10hotels.com/gallery/Icono_Personas.svg" alt="" />
                                    </span>
                                    <span>Equipo profesional</span>
                                </li>
                                <li className="col-12 col-sm-3">
                                    <span className="round">
                                        <img src="https://pro-static.h10hotels.com/gallery/Icono_Sofa.svg" alt="" />
                                    </span>
                                    <span>Interiorismo como seña de identidad</span>
                                </li>
                                <li className="col-12 col-sm-3">
                                    <span className="round">
                                        <img src="https://pro-static.h10hotels.com/gallery/Icono_Cubiertos.svg" alt="Restaurante buffet con cocina en vivo" />
                                    </span>
                                    <span>Gastronomía de autor</span>
                                </li>
                                <li className="col-12 col-sm-3">
                                    <span className="round">
                                        <img src="https://pro-static.h10hotels.com/gallery/Icono_Terraza.svg" alt="Terraza" />
                                    </span>
                                    <span>Instalaciones constantemente actualizadas</span>
                                </li>
                                <li className="col-12 col-sm-3">
                                    <span className="round">
                                        <img src="https://pro-static.h10hotels.com/gallery/Icono_Hoja.svg" alt="Icono_Hoja" />
                                    </span>
                                    <span>Stay Green by H10 Hotels</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container d-flex align-items-center justify-content-center">
                <a className="btn btn-primary btn-lg">SOLICITAR PRESUPUESTO</a>
            </div>
        </>
    );
}

export default WhyChooseUs;
